import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Fab from '@material-ui/core/Fab';
import { config } from "../../../../config";
import UserContactCard from './UserContactCard';
import { userInst } from '../../../../util/utilFunction';

const UserProfileCard = ({headerStyle , user, onModalClose , closeButtonState}) => {
  return (
    <div className="jr-card text-center mb-0">
      <div className={`jr-card-header-color ${headerStyle}`}>
        <div className="jr-card-header-top">
          {/* <IconButton className="jr-fs-lg text-white" aria-label="Menu"><i className="zmdi zmdi-menu"/></IconButton> */}
          {closeButtonState ?          <IconButton className="icon-btn p-1 text-white ml-auto" onClick={onModalClose}><i className="zmdi zmdi-close"/></IconButton>
 : null }
        </div>

        <img className="rounded-circle size-90 avatar-shadow mb-3"
             src={config.apiUrl + user.profileImageUrl} alt={user.name+" "+user.surname}
             onError={(e)=>{e.target.onerror = null; e.target.src=config.apiUrl + config.defaultProfileImageUrl }}

             />

        <div className="jr-card-hd-content">
          <h5 className="mb-0 text-white">{user.title +" "+user.name+" "+user.surname}</h5>
          <p className="jr-fs-sm mb-0 text-grey text-lighten-2">{user.inst !== null ?userInst(user.inst) :''  }</p>
          <p className="jr-fs-sm mb-0 text-grey text-lighten-2">{user.department !== null ? user.department :''  }</p>

        </div>
        <Fab className="jr-badge-up bg-success"><i className="zmdi zmdi-mail-send"/></Fab>
      </div>
      <div className="pt-2">
        {/* <p className="card-text">

        {user.identityNo +" " + user.email +" "+user.tel+" "+user.gender}
        </p> */}
        <UserContactCard user={user} />
      </div>
    </div>
  )
};

export default UserProfileCard;

